import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_HOST || '';

const api = axios.create({ baseURL: BACKEND });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('token');
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export async function login(username, password) {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  const res = await api.post('/token', params);
  localStorage.setItem('token', res.data.access_token);
  return res.data;
}

export async function createJob(file, { mode, level, ...advancedFlags }) {
  const form = new FormData();
  form.append('file', file);
  form.append('mode', mode || 'age_estimation');
  if (level != null) form.append('level', level);
  const filtered = Object.fromEntries(
    Object.entries(advancedFlags).filter(([, v]) => v != null && v !== '')
  );
  if (Object.keys(filtered).length > 0) {
    form.append('advanced_flags', JSON.stringify(filtered));
  }
  const res = await api.post('/api/jobs', form);
  return res.data;
}

export async function getJobs() {
  const res = await api.get('/api/jobs');
  return res.data;
}

export async function getJob(jobId) {
  const res = await api.get(`/api/jobs/${jobId}`);
  return res.data;
}

export async function getEstimate(rowCount, mode, level, linkedinEngine, overrides, serperPlan, serpapiPlan) {
  const params = { row_count: rowCount, mode, level, linkedin_engine: linkedinEngine };
  if (serperPlan) params.serper_plan = serperPlan;
  if (serpapiPlan) params.serpapi_plan = serpapiPlan;
  if (overrides && Object.keys(overrides).length > 0) {
    params.overrides = JSON.stringify(overrides);
  }
  const res = await api.get('/api/jobs/estimate', { params });
  return res.data;
}

export async function getJobLogs(jobId, { sinceId, tail } = {}) {
  const params = {};
  if (tail) params.tail = tail;
  else if (sinceId) params.since_id = sinceId;
  const res = await api.get(`/api/jobs/${jobId}/logs`, { params });
  return res.data;
}

export async function getFileStats(filename, mode) {
  const res = await api.get('/api/jobs/file-stats', {
    params: { filename, mode },
  });
  return res.data;
}

export async function cancelJob(jobId) {
  const res = await api.post(`/api/jobs/${jobId}/cancel`);
  return res.data;
}

export async function syncToHubspot(jobId, retryFailed = false) {
  const res = await api.post(`/api/jobs/${jobId}/sync`, { retry_failed: retryFailed });
  return res.data;
}

export function downloadUrl(jobId) {
  const token = localStorage.getItem('token');
  return `${BACKEND}/api/jobs/${jobId}/download?token=${token}`;
}

export default api;
